import { useEffect, useState } from 'react';

const subscribersObj1: (() => void)[] = [];

export const useSelector = <T, T2>(state: T2, selector: (state: T2) => T): T => {
  const deepSelector = (state: T2) => (typeof selector(state) === 'object' ? { ...selector(state) } : selector(state));
  const [s, setState] = useState<T>(deepSelector(state));

  useEffect(() => {
    const callback = () => {
      setState(prev => {
        if (JSON.stringify(deepSelector(state)) !== JSON.stringify(prev)) {
          return deepSelector(state);
        }
        return prev;
      });
    };

    subscribersObj1.push(callback);

    return () => {
      const index = subscribersObj1.indexOf(callback);

      if (index > -1) subscribersObj1.splice(index, 1);
    };
  }, [deepSelector]);

  return s;
};

export const State = <T, T2>({
  state,
  children,
  selector
}: {
  state: T2;
  children: (props: T) => React.ReactElement;
  selector: (state: T2) => T;
}) => {
  const deepSelector = (state: T2) => (typeof selector(state) === 'object' ? { ...selector(state) } : selector(state));
  const [s, setState] = useState<T>(deepSelector(state));

  useEffect(() => {
    const callback = () => {
      setState(prev => {
        if (JSON.stringify(deepSelector(state)) !== JSON.stringify(prev)) {
          return deepSelector(state);
        }
        return prev;
      });
    };

    subscribersObj1.push(callback);

    return () => {
      const index = subscribersObj1.indexOf(callback);

      if (index > -1) subscribersObj1.splice(index, 1);
    };
  }, [deepSelector]);

  return <>{children(s)}</>;
};

export const dispatch = <T, _>(obj: T, updater: (draft: typeof obj) => void) => {
  updater(obj);

  // const copyObj = JSON.parse(JSON.stringify(obj));

  // if (typeof obj === 'object') {
  //   Object.entries(copyObj || {}).forEach(([k, v]) => {
  //     (obj as Record<string, any>)[k] = v;
  //   });
  // }

  // console.log(subscribersObj1, 'subscribersObj1');

  subscribersObj1.forEach(callback => callback());
};
